import axios from "axios";

export default axios.create({
    baseURL: "https://api.hexai.dev/",
    headers: {
        "Content-type": "application/json"
    }
});